export default __webpack_public_path__ + "static/funky-lines-259221c42f13cb6b133c068e49dff582.png";